import { Component } from '@angular/core'

@Component({
  selector: 'ftr-not-found-page',
  template: '<ftr-not-found></ftr-not-found>',
  standalone: false,
})
export class NotFoundPage {}
